module.exports = __webpack_public_path__ + "../resources/img/pv_cal_img2.ccf24f67.png";